var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-wrap" },
    [
      _vm._m(0),
      _c(
        "el-container",
        { staticClass: "contract-tpl" },
        [
          _c(
            "el-main",
            { staticClass: "main" },
            [
              !_vm.$route.query.editorType
                ? _c("tpl-editor", {
                    ref: "tplEditor",
                    on: { editorReadyCallback: _vm.handleEditorReadyCallback }
                  })
                : _c("iframe", {
                    ref: "tipEditorRef",
                    staticStyle: { width: "100%", height: "60vh" },
                    attrs: { src: _vm.editorUrl, frameborder: "0" }
                  })
            ],
            1
          ),
          _c(
            "el-aside",
            { staticClass: "aside", attrs: { width: "260px" } },
            [
              _c("h4", [_vm._v("模板信息")]),
              _c(
                "el-form",
                {
                  ref: "tplFrm",
                  staticClass: "tpl-info",
                  attrs: {
                    model: _vm.tplFrm,
                    rules: _vm.tplFrmRules,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "tplName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "模板名称" },
                        model: {
                          value: _vm.tplFrm.tplName,
                          callback: function($$v) {
                            _vm.$set(_vm.tplFrm, "tplName", $$v)
                          },
                          expression: "tplFrm.tplName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "serialNum" } },
                    [
                      _vm.$route.query.tplId
                        ? _c("el-input", {
                            attrs: {
                              placeholder: "模板ID",
                              disabled: true,
                              readonly: true
                            },
                            model: {
                              value: _vm.tplFrm.serialNum,
                              callback: function($$v) {
                                _vm.$set(_vm.tplFrm, "serialNum", $$v)
                              },
                              expression: "tplFrm.serialNum"
                            }
                          })
                        : _c("el-input", {
                            attrs: { placeholder: "模板ID" },
                            model: {
                              value: _vm.tplFrm.serialNum,
                              callback: function($$v) {
                                _vm.$set(_vm.tplFrm, "serialNum", $$v)
                              },
                              expression: "tplFrm.serialNum"
                            }
                          })
                    ],
                    1
                  ),
                  false
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "tplGroupTypeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.tplFrm.tplGroupTypeId,
                                callback: function($$v) {
                                  _vm.$set(_vm.tplFrm, "tplGroupTypeId", $$v)
                                },
                                expression: "tplFrm.tplGroupTypeId"
                              }
                            },
                            [
                              _c("el-option", {
                                key: -1,
                                attrs: { label: "未分类", value: -1 }
                              }),
                              _vm._l(_vm.groupList, function(item) {
                                return _c("el-option", {
                                  key: item.tplGroupTypeId,
                                  attrs: {
                                    label: item.tplGroupTypeName,
                                    value: item.tplGroupTypeId
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", placeholder: "备注" },
                            model: {
                              value: _vm.tplFrm.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.tplFrm, "mark", $$v)
                              },
                              expression: "tplFrm.mark"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              _vm.showToTplPre = true
                            }
                          }
                        },
                        [_vm._v("预览")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.submitTplFrm()
                            }
                          }
                        },
                        [_vm._v("提交")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showToTplPre,
                title: "模板预览",
                width: "500px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showToTplPre = $event
                }
              }
            },
            [
              _c("div", [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tplPreParams,
                      expression: "tplPreParams"
                    }
                  ],
                  attrs: {
                    cols: "60",
                    rows: "10",
                    placeholder: "输入参数{key:value}"
                  },
                  domProps: { value: _vm.tplPreParams },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.tplPreParams = $event.target.value
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.tplPre()
                        }
                      }
                    },
                    [_vm._v("模拟")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.tplPrePdf()
                        }
                      }
                    },
                    [_vm._v("模拟pdf下载")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showTplPre,
                title: "模板预览",
                width: "60%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showTplPre = $event
                }
              }
            },
            [
              _c("iframe", {
                staticClass: "iframe-sty",
                attrs: { srcdoc: _vm.tplPreContext, title: _vm.tplFrm.tplName }
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      {
        staticClass: "com-title com-ht",
        staticStyle: { "margin-bottom": "20px" }
      },
      [
        _c("i"),
        _vm._v("新增api模板"),
        _c("span", { staticClass: "ms" }, [
          _vm._v("/ 设置合同固定条款，智能生成合同信息")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-795bd7a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795bd7a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/add/api.vue
// module id = Gbhm
// module chunks = 96